import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from './models/paginator.interfaces';

@Component({
  selector: 'idp-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @Input() content: Pagination;

  @Output() activePage: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
    this.content = this.initContent();
  }

  initContent(): Pagination {
    return {
      previous: '',
      next: '',
      indexes: [],
      pageSize: 0,
      first: 0,
      last: 0,
      ariaLabels: {
        title: '',
        previous: '',
        current: '',
        next: ''
      },
      activePage: 1
    };
  }

  /** Get the required page and notify about the active page to parent component */
  /** The parent component is in charge to handle the active page */
  setPage(index: number): void {
    this.activePage.emit(index);
  }

  /** Apply the aria label to the previous and next links as per the event demands */
  setAriaLabel(event: Event, ariaLabel: string) {
    (event.target as HTMLElement).setAttribute('aria-label', ariaLabel);
  }
}
